/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import _ from 'underscore';

import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import * as Headers from 'ui-library/Headers';
import PaddedBorderedCell from 'ui-library/internal/PaddedBorderedCell';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';
import SectionHeader from 'ui-library/menus/SectionHeader';
import copyToClipboard from 'util/clipboard/copyToClipboard';

type State = any;

class DropdownGuidelines extends React.Component<{}, State> {
  state: State = {
    value: 2,
    multiValue: [1, 3],
  };

  _handleSelect = (value: any): void => {
    notifications.success(`You clicked ${value}!`);
    this.setState({value});
  };

  _handleSelectMulti = (value: any): void => {
    notifications.success(`You clicked ${value}!`);
    if (this.state.multiValue.includes(value)) {
      // eslint-disable-next-line no-restricted-syntax
      this.setState({multiValue: _.without(this.state.multiValue, value)});
    } else {
      this.setState({multiValue: [...this.state.multiValue, value]});
    }
  };

  render(): JSX.Element {
    return (
      <div className="u-spacing">
        <Headers.Header1>Menus</Headers.Header1>
        <div>
          <a href="https://zpl.io/aMdgy3m">https://zpl.io/aMdgy3m</a>
        </div>
        <div>
          <code>ui-library/dropdowns/</code>
        </div>
        <div>
          <code>ui-library/menus/</code>
        </div>
        <Headers.Header2>Types</Headers.Header2>
        <Row>
          <Col xs={6}>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Text Only</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM} value={this.state.value}>
                    <Option value={1} onSelect={this._handleSelect}>
                      Option 1
                    </Option>
                    <Option value={2} onSelect={this._handleSelect} isDisabled={true}>
                      Option 2 (Disabled)
                    </Option>
                    <Option value={3} onSelect={this._handleSelect}>
                      Option 3
                      <Menu>
                        <Option value={4} onSelect={this._handleSelect}>
                          Option 4
                        </Option>
                        <Option value={5} onSelect={this._handleSelect}>
                          Option 5
                        </Option>
                      </Menu>
                    </Option>
                    {/* oxlint-disable-next-line no-constant-binary-expression */}
                    {false && (
                      <Option value={6} onSelect={this._handleSelect}>
                        Hidden option
                      </Option>
                    )}
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Text Only"
                />
              </Dropdown>
            </div>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Text + Icon</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu height={Menu.HEIGHTS.LARGE} width={Menu.WIDTHS.LARGE} value={this.state.value}>
                    <Option value={1} icon="search" onSelect={this._handleSelect}>
                      Option 1
                    </Option>
                    <Option value={2} icon="search" onSelect={this._handleSelect}>
                      Option 2
                    </Option>
                    <Option value={3} icon="search" onSelect={this._handleSelect}>
                      Option 3
                    </Option>
                    <Option value={4} icon="search" onSelect={this._handleSelect}>
                      Option 4
                    </Option>
                    <Option value={5} icon="search" onSelect={this._handleSelect}>
                      Option 5
                    </Option>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Text + Icon"
                />
              </Dropdown>
            </div>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Text + Icon + Metadata</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu height={Menu.HEIGHTS.XLARGE} width={Menu.WIDTHS.XLARGE} value={this.state.value}>
                    <Option value={1} icon="search" metadata="Metadata" onSelect={this._handleSelect}>
                      Option 1
                    </Option>
                    <Option value={2} icon="search" metadata="Metadata" onSelect={this._handleSelect}>
                      Option 2
                    </Option>
                    <Option value={3} icon="search" metadata="Metadata" onSelect={this._handleSelect}>
                      Option 3
                      <Menu>
                        <Option value={4} onSelect={this._handleSelect}>
                          Option 4
                        </Option>
                        <Option value={5} onSelect={this._handleSelect}>
                          Option 5
                        </Option>
                      </Menu>
                    </Option>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Text + Icon + Metadata"
                />
              </Dropdown>
            </div>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Copy to Clipboard</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu height={Menu.HEIGHTS.XLARGE} width={Menu.WIDTHS.XLARGE} value={0}>
                    <Option value={0}>
                      <div>Option 1 (no copy to clipboard)</div>
                    </Option>
                    <Option
                      value={1}
                      onSelect={() => {
                        copyToClipboard('This is the text', {showToastOnSuccess: true});
                      }}
                    >
                      <div>Select me to copy to clipboard</div>
                    </Option>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Copy to Clipboard"
                />
              </Dropdown>
            </div>
          </Col>
          <Col xs={6}>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Multi-select</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu
                    height={Menu.HEIGHTS.XLARGE}
                    width={Menu.WIDTHS.XLARGE}
                    value={this.state.multiValue}
                    isMulti={true}
                  >
                    <Option value={1} icon="search" metadata="Metadata" onSelect={this._handleSelectMulti}>
                      Option 1
                    </Option>
                    <Option value={2} icon="search" metadata="Metadata" onSelect={this._handleSelectMulti}>
                      Option 2
                    </Option>
                    <Option value={3} icon="search" metadata="Metadata" onSelect={this._handleSelectMulti}>
                      Option 3
                      <Menu>
                        <Option value={4} onSelect={this._handleSelectMulti}>
                          Option 4
                        </Option>
                        <Option value={5} onSelect={this._handleSelectMulti}>
                          Option 5
                        </Option>
                      </Menu>
                    </Option>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Multi"
                />
              </Dropdown>
            </div>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Sections</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.SMALL} value={this.state.value}>
                    <Section>
                      <SectionHeader>Section Header</SectionHeader>
                      <Option value={1} onSelect={this._handleSelect}>
                        Option 1
                      </Option>
                      <Option value={2} onSelect={this._handleSelect}>
                        Option 2
                      </Option>
                    </Section>
                    <Section>
                      <Option value={3} onSelect={this._handleSelect}>
                        Option 3
                        <Menu>
                          <Option value={4} onSelect={this._handleSelect}>
                            Option 4
                          </Option>
                          <Option value={5} onSelect={this._handleSelect}>
                            Option 5
                          </Option>
                        </Menu>
                      </Option>
                    </Section>
                    <Section>
                      {/* oxlint-disable-next-line no-constant-binary-expression */}
                      {false && (
                        <Option value={6} onSelect={this._handleSelect}>
                          Hidden option
                        </Option>
                      )}
                    </Section>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Sections"
                />
              </Dropdown>
            </div>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Drop Left</Headers.Sublabel>
              <Dropdown
                menu={
                  <Menu
                    height={Menu.HEIGHTS.MEDIUM}
                    width={Menu.WIDTHS.SMALL}
                    dropLeft={true}
                    value={this.state.value}
                  >
                    <Option value={1} onSelect={this._handleSelect}>
                      Option 1
                    </Option>
                    <Option value={2} onSelect={this._handleSelect}>
                      Option 2
                    </Option>
                    <Option value={3} onSelect={this._handleSelect}>
                      Option 3
                      <Menu>
                        <Option value={4} onSelect={this._handleSelect}>
                          Option 4
                        </Option>
                        <Option value={5} onSelect={this._handleSelect}>
                          Option 5
                          <Menu>
                            <Option value={6} onSelect={this._handleSelect}>
                              Option 6
                            </Option>
                            <Option value={7} onSelect={this._handleSelect}>
                              Option 7
                            </Option>
                          </Menu>
                        </Option>
                      </Menu>
                    </Option>
                  </Menu>
                }
              >
                <Button
                  buttonStyle={ButtonStyle.PRIMARY}
                  isDropdown={true}
                  size={ButtonSize.MEDIUM}
                  text="Drop Left"
                />
              </Dropdown>
            </div>
          </Col>
        </Row>
        <Headers.Header2>Toggle Types</Headers.Header2>
        <div className="u-spacing-bottom">
          <Headers.Sublabel>Select Dropdown</Headers.Sublabel>
          <div style={{width: '400px'}}>
            <SelectDropdown
              menu={
                <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={this.state.value}>
                  <Option value={1} onSelect={this._handleSelect}>
                    Option 1
                  </Option>
                  <Option value={2} onSelect={this._handleSelect}>
                    Option 2
                  </Option>
                  <Option value={3} onSelect={this._handleSelect}>
                    Option 3
                    <Menu>
                      <Option value={4} onSelect={this._handleSelect}>
                        Option 4
                      </Option>
                      <Option value={5} onSelect={this._handleSelect}>
                        Option 5
                      </Option>
                    </Menu>
                  </Option>
                </Menu>
              }
              displayName="Pick one..."
            />
          </div>
        </div>
        <Headers.Header2>Sizes</Headers.Header2>
        <table>
          <thead>
            <tr>
              <PaddedBorderedCell />
              <PaddedBorderedCell>
                <Headers.Sublabel>Medium</Headers.Sublabel>
              </PaddedBorderedCell>
              <PaddedBorderedCell>
                <Headers.Sublabel>Large</Headers.Sublabel>
              </PaddedBorderedCell>
              <PaddedBorderedCell>
                <Headers.Sublabel>X-Large</Headers.Sublabel>
              </PaddedBorderedCell>
            </tr>
          </thead>
          <tbody>
            {Object.values(Menu.WIDTHS).map((width) => (
              <tr key={width}>
                <PaddedBorderedCell>
                  <Headers.Sublabel>{width}</Headers.Sublabel>
                </PaddedBorderedCell>
                {Object.values(Menu.HEIGHTS).map((height) => (
                  <PaddedBorderedCell key={`${width}-${height}`}>
                    <Dropdown
                      menu={
                        <Menu height={height} width={width} value={this.state.value}>
                          <Option value={1} onSelect={this._handleSelect}>
                            Option 1
                          </Option>
                          <Option value={2} onSelect={this._handleSelect}>
                            Option 2
                          </Option>
                          <Option value={3} onSelect={this._handleSelect}>
                            Option 3
                            <Menu>
                              <Option value={4} onSelect={this._handleSelect}>
                                Option 4
                              </Option>
                              <Option value={5} onSelect={this._handleSelect}>
                                Option 5
                              </Option>
                            </Menu>
                          </Option>
                        </Menu>
                      }
                    >
                      <Button
                        buttonStyle={ButtonStyle.SECONDARY}
                        isDropdown={true}
                        size={ButtonSize.SMALL}
                        text={`${width} / ${height}`}
                      />
                    </Dropdown>
                  </PaddedBorderedCell>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default DropdownGuidelines;
